export default "__VITE_ASSET__ac7872c1__"